// Access the strings used on the OnBoarding page.
export const t_onboarding = {
    title: "signup.onboarding.title",
    subtitle: "signup.onboarding.subtitle",
    body: "signup.onboarding.body",
  };